<script>
import { mapState } from 'vuex';
import Banner from '../../components/banner.vue';
import Logos from '../../components/logos.vue';

export default {
    name: "operate",
    data() {
        return {
            
        };
    },
    computed: {
        ...mapState(['operateData']),
    },
    components: {
        Banner, Logos
    },
    mounted() {
        this.$store.dispatch('getOperateData');
    },
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="operate">
        <Banner :banner="operateData.info.image" :title="operateData.info.name" :desc="operateData.info.desc"/>
        <router-view></router-view>
        <Logos v-if="operateData.website.length > 0" :data="operateData.website"/>
    </div>
</template>

<style scoped lang="scss">

</style>